import { CATEGORY_ID_SYSTEM_NAME, KUX_FEATURE_NAME, MAIN_VIRTUAL_ASSET_STRUCT_NAME } from '../../utils/constants';

interface StructDefinition {
  name: string;
  metas: string[];
  features: string[];
  isProtected?: boolean;
}

export const BASIC_CATEGORY_STRUCTS: { [key: string]: StructDefinition } = {
  [MAIN_VIRTUAL_ASSET_STRUCT_NAME]: {
    name: MAIN_VIRTUAL_ASSET_STRUCT_NAME,
    metas: [CATEGORY_ID_SYSTEM_NAME],
    isProtected: true,
    features: [KUX_FEATURE_NAME],
  },
  root_category: {
    name: 'Root Category',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'btn_font_size',
      'btn_text_color',
      'btn_text_color_focus',
      'btn_background_color',
      'btn_background_color_focus',
      'btn_background_opacity',
      'color_past',
      'color_present',
      'color_future',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'filtering_kSQL',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'hide_parental_assets',
      'hide_parental_assets_kSQL',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'present_app_icon_platform_denylist',
      'present_clock_platform_denylist',
      'asset_presentation_form',
      'concurrency_buymore',
      'concurrency_player_error_ttl',
      'prime_time',
      'default_channel',
      'present_player',
      'recommendation_fields',
      'cache_linear_channel_list',
      'global_linear_channels_collection_id',
      'linear_channels_filtering_kSQL',
      'linear_channels_batches_presentation_order',
      'present_X_most_watched_count',
      'present_X_most_watched_period',
      'asset_image_height',
      'present_current_programs',
      'program_refresh_frequency',
      'present_mute_platform_denylist',
      'present_rating',
      'rating_provider',
      'present_rating_source_logo',
      'purchase_device_brand_denial_list',
      'display_logout_button',
      'player_language_codes',
      'display_name',
    ],
    features: [KUX_FEATURE_NAME],
  },
  aside: {
    name: 'Aside Folder',
    metas: ['UIDA_structure_type', 'UIDA_presentation_type'],
    features: [KUX_FEATURE_NAME],
  },
  home_page: {
    name: 'Home Page (Container/Theme)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'parental_pin_protected',
      'filtering_kSQL',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'hide_parental_assets',
      'hide_parental_assets_kSQL',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'present_app_icon_platform_denylist',
      'present_clock_platform_denylist',
      'asset_presentation_form',
      'default_channel',
      'present_player',
      'present_X_most_watched_count',
      'present_X_most_watched_period',
      'linear_channels_batches_presentation_order',
      'present_current_programs',
      'program_refresh_frequency',
      'present_mute_platform_denylist',
      'present_rating',
      'rating_provider',
      'present_rating_source_logo',
      'anchors',
    ],
    features: [KUX_FEATURE_NAME],
  },
  page: {
    name: 'General Page (Container)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'present_favorite_indicator',
      'parental_pin_protected',
      'present_entitlement_indicator',
      'default_linear_channel',
      'filtering_kSQL',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'hide_parental_assets',
      'hide_parental_assets_kSQL',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'present_app_icon_platform_denylist',
      'present_clock_platform_denylist',
      'asset_presentation_form',
      'asset_image_height',
      'default_channel',
      'present_player',
      'present_X_most_watched_count',
      'present_X_most_watched_period',
      'linear_channels_batches_presentation_order',
      'present_current_programs',
      'program_refresh_frequency',
      'present_mute_platform_denylist',
      'present_rating',
      'rating_provider',
      'present_rating_source_logo',
      'anchors',
    ],
    features: [KUX_FEATURE_NAME],
  },
  menu_widget: {
    name: 'Menu (Widget)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'filtering_kSQL',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'hide_parental_assets',
      'hide_parental_assets_kSQL',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'present_app_icon_platform_denylist',
      'present_clock_platform_denylist',
      'default_channel',
      'present_X_most_watched_count',
      'present_X_most_watched_period',
      'linear_channels_batches_presentation_order',
      'present_current_programs',
      'program_refresh_frequency',
      'present_mute_platform_denylist',
      'asset_presentation_form',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'asset_image_height',
      'asset_image_source',
    ],
    features: [KUX_FEATURE_NAME],
  },
  hero_widget: {
    name: 'Hero (Widget)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'default_linear_channel',
      'filtering_kSQL',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'hide_parental_assets',
      'hide_parental_assets_kSQL',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'present_app_icon_platform_denylist',
      'present_clock_platform_denylist',
      'default_channel',
      'present_player',
      'present_X_most_watched_count',
      'present_X_most_watched_period',
      'linear_channels_batches_presentation_order',
      'present_current_programs',
      'program_refresh_frequency',
      'asset_presentation_form',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'asset_image_height',
      'asset_image_source',
      'present_show_more',
      'type_of_app_link',
      'in_app_link',
      'rail_items_limit',
      'present_mute_platform_denylist',
      'present_rating',
      'rating_provider',
      'present_rating_source_logo',
      'group_by',
      'channel_presentation_image_type',
      'target_grid_category_id',
      'enable_filter_by_entitlement',
      'second_button_action',
    ],
    features: [KUX_FEATURE_NAME],
  },
  continue_watching_widget: {
    name: 'Continue Watching (Widget)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'filtering_kSQL',
      'enable_filter_by_entitlement',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'hide_parental_assets',
      'hide_parental_assets_kSQL',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'present_app_icon_platform_denylist',
      'present_clock_platform_denylist',
      'statusEqual',
      'typeIn',
      'asset_presentation_form',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'asset_image_height',
      'asset_image_source',
      'present_show_more',
      'type_of_app_link',
      'in_app_link',
      'show_top_shelf_rail_ui',
      'rail_items_limit',
      'default_channel',
      'present_player',
      'present_X_most_watched_count',
      'present_X_most_watched_period',
      'linear_channels_batches_presentation_order',
      'present_current_programs',
      'program_refresh_frequency',
      'present_mute_platform_denylist',
      'present_rating',
      'rating_provider',
      'present_rating_source_logo',
      'target_grid_category_id',
      'use_suppress',
      'group_by',
    ],
    features: [KUX_FEATURE_NAME],
  },
  collection_widget: {
    name: 'Collection (Widget)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'parental_pin_protected',
      'filtering_kSQL',
      'enable_filter_by_entitlement',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'hide_parental_assets',
      'hide_parental_assets_kSQL',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'present_app_icon_platform_denylist',
      'present_clock_platform_denylist',
      'asset_presentation_form',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'asset_image_height',
      'asset_image_source',
      'present_show_more',
      'type_of_app_link',
      'in_app_link',
      'show_top_shelf_rail_ui',
      'rail_items_limit',
      'default_channel',
      'present_player',
      'present_X_most_watched_count',
      'present_X_most_watched_period',
      'linear_channels_batches_presentation_order',
      'present_current_programs',
      'program_refresh_frequency',
      'present_mute_platform_denylist',
      'present_rating',
      'rating_provider',
      'present_rating_source_logo',
      'group_by',
      'target_grid_category_id',
      'hide_titles',
    ],
    features: [KUX_FEATURE_NAME],
  },
  tvod_widget: {
    name: 'TVOD Rail (Widget)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'parental_pin_protected',
      'filtering_kSQL',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'hide_parental_assets',
      'hide_parental_assets_kSQL',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'present_app_icon_platform_denylist',
      'present_clock_platform_denylist',
      'asset_presentation_form',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'asset_image_height',
      'asset_image_source',
      'present_show_more',
      'type_of_app_link',
      'in_app_link',
      'show_top_shelf_rail_ui',
      'rail_items_limit',
      'target_grid_category_id',
      'present_rating',
      'rating_provider',
      'present_rating_source_logo',
      'group_by',
    ],
    features: [KUX_FEATURE_NAME],
  },

  applications_widget: {
    name: 'Applications (Widget)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'asset_presentation_form',
      'asset_image_height',
      'present_show_more',
      'type_of_app_link',
      'in_app_link',
      'rail_items_limit',
    ],
    features: [KUX_FEATURE_NAME],
  },
  zapper_widget: {
    name: 'Zapper (Widget)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'color_past',
      'color_present',
      'color_future',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'device_brand_denial_list_for_ui_components',
      'max_epg_date_backward',
      'max_epg_date_forward',
      'asset_image_height',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'present_X_most_watched_count',
      'present_X_most_watched_period',
      'linear_channels_batches_presentation_order',
      'zapper_show_duration_in_seconds',
      'present_favorite_indicator',
    ],
    features: [KUX_FEATURE_NAME],
  },
  epg_page: {
    name: 'EPG Grid (Page)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'default_linear_channel',
      'color_past',
      'color_present',
      'color_future',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'filtering_kSQL',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'present_X_most_watched_count',
      'present_X_most_watched_period',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'max_epg_date_backward',
      'max_epg_date_forward',
      'linear_channels_batches_presentation_order',
      'present_filter_entitled',
      'present_filter_favorite',
      'present_filter_X_watched',
      'anchors',
    ],
    features: [KUX_FEATURE_NAME],
  },
  login_page: {
    name: 'Login Page (Aside)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'signup_url',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'anchors',
    ],
    features: [KUX_FEATURE_NAME],
  },
  /**
   * https://kaltura.atlassian.net/wiki/spaces/KUXDEV/pages/2205057193/Pages#Top-shelf-widget
   */
  top_shelf_widget: {
    name: 'Top Shelf Widget (Aside)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'present_rating',
      'rating_provider',
      'present_rating_source_logo',
      'asset_presentation_image_type',
    ],
    features: [KUX_FEATURE_NAME],
  },
  top_shelf_carousel_widget: {
    name: 'Top Shelf Carousel',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'anchors',
      'auto_transition_delay',
      'asset_image_height',
      'asset_presentation_image_type',
      'background_color',
      'cover_image_type',
      'device_brand_denial_list_for_ui_components',
      'focus_color',
      'font_size',
      'font_type',
      'group_by',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'hide_parental_assets',
      'hide_parental_assets_kSQL',
      'filter_by_entitlement_indicator',
      'filtering_kSQL',
      'present_entitlement_indicator',
      'present_rating',
      'rail_items_limit',
      'selected_color',
      'text_color',
      'user_type_denial_list_for_ui_components',
    ],
    features: [KUX_FEATURE_NAME],
  },
  subscription_page: {
    name: 'Subscription (Settings Subpage)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'hide_prices',
      'external_portal_url',
      'addon_collection',
      'hero_collection',
      'not_applicable_collection',
      'allow_cancellation',
      'anchors',
    ],
    features: [KUX_FEATURE_NAME],
  },
  asset_details_page: {
    name: 'Asset Details Page',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'asset_struct',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'asset_image_height',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'purchase_allow_coupons',
      'rental_badge_boundary',
      'anchors',
      'enable_filter_episodes_by_entitlement',
    ],
    features: [KUX_FEATURE_NAME],
  },
  blocked_channels: {
    name: 'Blocked Channels',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'asset_image_height',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
    ],
    features: [KUX_FEATURE_NAME],
  },
  apps_page: {
    name: 'Applications PAge',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'asset_image_height',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'anchors',
    ],
    features: [KUX_FEATURE_NAME],
  },
  parent_control: {
    name: 'Parent  Control (Settings Subpage)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'asset_image_height',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'parental_age_groups',
      'parental_pin_protected',
    ],
    features: [KUX_FEATURE_NAME],
  },
  favorites_page: {
    name: 'Favorites (Settings Subpage)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'asset_image_height',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'anchors',
      'enable_filter_by_entitlement',
      'favorites_ttl',
    ],
    features: [KUX_FEATURE_NAME],
  },
  preferred_video_page: {
    name: 'Preferred Video Page (Settings Subpage)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'anchors',
      'enable_idle_message',
      'enable_user_idle_message_management',
      'idle_message_lifecycle',
      'idle_message_duration',
    ],
    features: [KUX_FEATURE_NAME],
  },
  language_subpage: {
    name: 'Language (Settings Subpage)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'asset_image_height',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
    ],
    features: [KUX_FEATURE_NAME],
  },
  devices_subpage: {
    name: 'Devices Mngmnt (Settings Subpage)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'asset_image_height',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
    ],
    features: [KUX_FEATURE_NAME],
  },
  link_list_subpage: {
    name: 'Link List (Settings Subpage)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'asset_image_height',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
    ],
    features: [KUX_FEATURE_NAME],
  },
  transaction_history: {
    name: 'Transaction History (Settings Subpage)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'asset_image_height',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
    ],
    features: [KUX_FEATURE_NAME],
  },
  device_info: {
    name: 'Device Info (Settings Subpage)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'anchors',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'selected_color',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
    ],
    features: [KUX_FEATURE_NAME],
  },
  generic_subpage: {
    name: 'Generic Subpage (Settings Subpage)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
    ],
    features: [KUX_FEATURE_NAME],
  },
  in_application_link_asset: {
    name: 'Link as Asset',
    metas: [
      'type_of_app_link',
      'in_app_link',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'target_grid_category_id',
      'attached_collection_id',
      'asset_image_height',
      'button_type',
    ],
    features: [KUX_FEATURE_NAME],
  },
  category_menu_item: {
    name: 'Menu Item',
    metas: [
      'UIDA_structure_type', // menu
      'UIDA_presentation_type', // menu_item
      'type_of_app_link',
      'in_app_link', // Can be external link, inneral page / grid page / ancors
      'attached_collection_id',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'asset_image_height',
      'menu_item_pined',
      'display_type',
    ],
    features: [KUX_FEATURE_NAME],
  },
  category_sub_menu: {
    name: 'Sub Menu',
    metas: [
      'UIDA_structure_type', // menu
      'UIDA_presentation_type', // menu_sub
    ],
    features: [KUX_FEATURE_NAME],
  },
  npvr_widget: {
    name: 'Recordings - NpVR (Widget)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'recording_type',
      'recording_expiration_boundary',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'asset_presentation_form',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'asset_image_height',
      'present_show_more',
      'type_of_app_link',
      'in_app_link',
      'rail_items_limit',
      'present_rating',
      'rating_provider',
      'new_episode_badge_days',
      'present_rating_source_logo',
      'target_grid_category_id',
      'enable_filter_by_entitlement',
      'image_height_compact',
      'image_height_medium',
    ],
    features: [KUX_FEATURE_NAME],
  },
  npvr_page: {
    name: 'Recordings - NpVR (Page)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'recording_expiration_boundary',
      'npvr_unlimited_quota',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'asset_presentation_form',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'new_episode_badge_days',
      'anchors',
      'enable_filter_by_entitlement',
      'image_height_compact',
      'image_height_medium',
    ],
    features: [KUX_FEATURE_NAME],
  },
  grid_widget: {
    name: 'Widget Grid',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'hide_adult_assets',
      'hide_parental_assets',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'filtering_kSQL',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'asset_presentation_form',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'asset_image_height',
      'present_rating',
      'rating_provider',
      'present_rating_source_logo',
      'present_show_more',
      'type_of_app_link',
      'in_app_link',
      'group_by',
      'image_height_compact',
      'image_height_medium',
    ],
    features: [KUX_FEATURE_NAME],
  },
  grid_page: {
    name: 'Page Grid',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'asset_presentation_form',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'asset_image_height',
      'present_rating',
      'rating_provider',
      'present_rating_source_logo',
      'anchors',
      'image_height_compact',
      'image_height_medium',
    ],
    features: [KUX_FEATURE_NAME],
  },
  channel_api: {
    name: 'Channel API (Widget)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'search_channel_phrase',
      'search_channel_package_phrase',
    ],
    features: [KUX_FEATURE_NAME],
  },
  search_page: {
    name: 'Search Page',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'anchors',
      'background_color',
      'collection_filtering_kSQL',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'hide_adult_assets',
      'hide_adult_assets_kSQL',
      'hide_parental_assets',
      'hide_parental_assets_kSQL',
      'user_type_denial_list_for_ui_components',
      'device_brand_denial_list_for_ui_components',
      'filtering_kSQL',
      'present_filter_entitled',
      'present_filter_favorite',
      'asset_presentation_ratio',
      'asset_presentation_image_type',
      'asset_image_height',
      'parental_pin_protected',
      'end_search_time_in_milliseconds',
      'recommendations_collection_id',
      'search_main_discovery_attributes',
      'max_numbers_of_history_search_list',
      'sorting_type',
      'image_height_compact',
      'image_height_medium',
      'group_by_is_enabled',
      'group_by_object',
      'group_by_unmatched_items_policy',
      'group_by_representative_policy_object',
      'order_by_policy_object',
    ],
    features: [KUX_FEATURE_NAME],
  },
  series_recordings_page: {
    name: 'Series Recordings (Page)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'anchors',
      'recording_expiration_boundary',
      'background_color',
      'text_color',
      'font_type',
      'font_size',
      'focus_color',
      'selected_color',
      'parental_pin_protected',
      'present_favorite_indicator',
      'present_entitlement_indicator',
      'series_type_scheduled_recordings_rail_title',
    ],
    features: [KUX_FEATURE_NAME],
  },
  player_widget: {
    name: 'Player (Widget)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'main_progress_bar_color',
      'secondary_progress_bar_color',
      'placeholder_progress_bar_color',
      'on_hover_color',
      'display_btn_epg_navigation',
      'jump_to_live_after_pause_x_minutes',
      'player_one_click_move_in_sec',
      'check_connectivity_when_buffer_after_sec',
      'livedvr_default_time',
      'live_popup_time_in_sec',
      'multicast_endpoint',
      'multicast_indication_value',
      'multicast_pause_resume_ABR_threshold',
      'WVCAS_capable',
      'HEVC_capable',
      'default_audio_codes',
      'default_subtitles_codes',
      'DRM_capable',
      'HEVC_DENY_LIST',
      'DRM_DENY_LIST',
      'HEVC_ERRORS_FALLBACK_LIMITAION',
      'zapperDisplayEnabled',
      'seek_with_thumbnails_denial_list',
      'keep_alive_beacons_frequency',
    ],
    features: [KUX_FEATURE_NAME],
  },
  deeplink_page: {
    name: 'Deeplink (Page)',
    metas: [
      'UIDA_structure_type',
      'UIDA_presentation_type',
      'background_color',
      'text_color',
      'android_fallback_page_address',
      'apple_fallback_page_address',
    ],
    features: [KUX_FEATURE_NAME],
  },
};
